import React from 'react';

import { Box, BoxProps } from '@tanium/react-box';
import { ThemeFontWeights } from '@tanium/theme-data';

import { ExtendAndOverride } from '../../utils/ExtendAndOverride';
import { TruncatedLabel } from '../TruncatedLabel';

interface OwnProps {
  /**
   * The label to show inside the badge. e.g., "Needs Improvement".
   */
  label: React.ReactNode;
  /**
   * The threshold to display in the badge.
   */
  threshold: React.ReactNode;
}

export type BadgeLabelProps = ExtendAndOverride<OwnProps, Omit<BoxProps, 'css'>>;

export const BadgeLabel = ({ label, threshold, ...boxProps }: BadgeLabelProps): JSX.Element => (
  <Box display="flex" {...boxProps}>
    <TruncatedLabel>{label}</TruncatedLabel>
    <Box pl={1} borderLeft={1} borderColor="currentColor" ml={1} fontWeight={ThemeFontWeights.Bold} flexShrink={0}>
      {threshold}
    </Box>
  </Box>
);
